module.exports = __webpack_public_path__ + "static/media/icon_robot_red.23247231.svg";